// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"DuplicateNamesModal-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DuplicateNamesModal/DuplicateNamesModal.desktop.scss
 ** module id = 911
 ** module chunks = 1
 **/